import { useEffect } from "react";

export default function Service() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal">
            <div className="container">
                <h1>Service Delivery Policy – CloTech AI Pvt. Ltd.</h1>
                <p><strong>Effective Date:</strong> 18.09.2025<br /><strong>Last Updated:</strong> 18.09.2025</p>
                <p>At CloTech AI Pvt. Ltd. (“CloTech AI”, “we”, “our”, “us”), we provide subscription-based CRM software and services. This Service Delivery Policy outlines how our products and services are provisioned, delivered, and supported.</p>
                <hr />
                <h2>1. Service Activation</h2>
                <ul>
                    <li>Once payment is confirmed, your subscription will be activated within 1–2 business days.</li>
                    <li>Login credentials and access details will be sent to your registered email address.</li>
                    <li>If you purchase add-ons (users, branches, modules, messaging packs, email services, WhatsApp services), they will be activated after payment confirmation.</li>
                </ul>
                <hr />
                <h2>2. Service Delivery Mode</h2>
                <ul>
                    <li>All our products are delivered digitally; there is no physical shipping.</li>
                    <li>Services are accessible via web browser on desktop, tablet, or mobile.</li>
                    <li>Setup, onboarding, and training are provided remotely through email, WhatsApp, video calls, or online documentation.</li>
                </ul>
                <hr />
                <h2>3. Onboarding &amp; Setup</h2>
                <ul>
                    <li>Basic onboarding is included with all plans.</li>
                    <li>Additional setup, customization, or extended hand-holding support may involve extra charges, which will be communicated in advance.</li>
                </ul>
                <hr />
                <h2>4. Timelines</h2>
                <ul>
                    <li>Standard CRM access: within 1–2 business days after payment.</li>
                    <li>Add-ons or module activations: typically within 1–2 business days.</li>
                    <li>In case of delays due to unforeseen technical issues, we will inform you promptly.</li>
                </ul>
                <hr />
                <h2>5. Service Availability</h2>
                <ul>
                    <li>CloTech AI CRM is a cloud-based platform, available 24×7, except during planned maintenance or unexpected outages.</li>
                    <li>We aim to minimize downtime and will notify customers in advance of scheduled maintenance.</li>
                    <li>However, in case of unexpected issues or third-party outages, prior notification may not be possible.</li>
                </ul>
                <hr />
                <h2>6. Customer Responsibilities</h2>
                <ul>
                    <li>Provide accurate information at the time of purchase (email, contact number, company details).</li>
                    <li>Maintain secure access to your login credentials.</li>
                    <li>Export and back up your data periodically for your own records.</li>
                </ul>
                <hr />
                <h2>7. Support</h2>
                <ul>
                    <li>Buds and Bloom users: support via chat/email.</li>
                    <li>Blossom users: priority support via chat, email, and optional voice call.</li>
                    <li>For delivery or activation-related queries: <a href="mailto:info@clotechai.com">info@clotechai.com</a> or WhatsApp <a href="https://wa.me/919038168162" target="_blank" rel="noopener noreferrer">+91 9038168162</a>.</li>
                    <li>For issue resolution and technical support: <a href="mailto:support@clotechai.com">support@clotechai.com</a> or WhatsApp <a href="https://wa.me/919038168162" target="_blank" rel="noopener noreferrer">+91 9038168162</a>.</li>
                </ul>
                <hr />
                <h2>8. Contact &amp; Communication Address</h2>

                <p>
                    For any questions or concerns regarding these Terms, please <a href="/contact">contact us</a>.
                </p>
            </div>
        </div>
    );
}
